import Header from "../../components/header/header";
import Footer from "../../components/footer/footer";
import { useLocation } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { REACT_APP_TICKETING_ORIGIN } from "../../../config";

const Tickets = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const isHeadless = searchParams.get("headless");
  const iframeRef = useRef<HTMLIFrameElement | null>(null);
  const [iframeHeight, setIframeHeight] = useState<string>("1000px"); // default

  const rawUser = localStorage.getItem("tygo_user");
  const TICKETING_ORIGIN = "https://test.ticketingweb.tygo.net";

  //   REACT_APP_TICKETING_ORIGIN;
  //   ("");

  console.log("TICKETING_ORIGIN:", TICKETING_ORIGIN);

  const sendUserToIframe = (
    targetWindow: Window,
    targetOrigin: string = TICKETING_ORIGIN!
  ) => {
    if (!rawUser) {
      console.warn("No tygo_user in localStorage");
      return;
    }

    let userObj: any;
    try {
      userObj = JSON.parse(rawUser);
    } catch (e) {
      console.error("Failed to parse tygo_user from localStorage", e);
      return;
    }

    targetWindow.postMessage(
      {
        type: "user",
        user: userObj,
      },
      targetOrigin
    );
  };

  useEffect(() => {
    // 🔹 Listen for READY from web view
    console.log("Setting up message listener for ticketing iframe");
    const handleMessage = (event: MessageEvent) => {
      // Only accept messages from the ticketing web view
      if (event.origin !== TICKETING_ORIGIN) {
        return;
      }

      if (
        event.data?.type === "TICKETING_RESIZE" &&
        typeof event.data.height === "number"
      ) {
        setIframeHeight(`${event.data.height}px`);
      }

      console.log("Received message from ticketing iframe:", event.data);
      if (!event.data || typeof event.data !== "object") return;

      if (event.data.type === "TICKET_WEBVIEW_READY") {
        console.log("Ticketing iframe is ready, sending user data");
        // event.source is the iframe's window
        const targetWindow = event.source as Window;
        sendUserToIframe(targetWindow, event.origin);
      }
    };

    console.log("Adding message listener for ticketing iframe");
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [rawUser]);

  return (
    <div
      style={{
        backgroundImage: "url(./media/hero/bg2.png)",
        backgroundColor: "#F7F7F7",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundAttachment: "fixed",
        minHeight: "100vh",
      }}
    >
      <div className="container">
        {!isHeadless && <Header />}
        <iframe
          ref={iframeRef}
          src={`${TICKETING_ORIGIN}/tickets`}
          title="Tickets"
          style={{
            width: "100%",
            height: iframeHeight,
            border: "none",
            display: "block",
            overflow: "visible",
          }}
        />
      </div>

      <Footer />
    </div>
  );
};

export default Tickets;
